import axios from "axios";
import Moment from "moment";
import CryptoJS from "crypto-js";
import moment from "moment/moment";
import {showToast} from "./tostr";
import get from "lodash.get";
import {setEnvMetadataIntoLocalStorage} from "./EnvMetaDataUtil";
import {apiErrorBasedRedirection} from "./handlers";

axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}/api/i`;
axios.defaults.headers.common["Content-Type"] = "application/json";
const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const login = async (email, password) => {
    let date = new Date();
    let year = date.getFullYear();
    let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    let month = date.getMonth() < 10 ? "0" + date.getMonth() : date.getMonth();
    let key = "9@E" + year + "#T7" + day + "rl" + month;
    const encryptedBase64Key = btoa(key);
    const secretKey = CryptoJS.enc.Base64.parse(encryptedBase64Key);
    const encryptedPassword = CryptoJS.AES.encrypt(password, secretKey, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
    }).toString();
    const response = await axios({
        url: "/signin",
        baseURL: `${baseURL}/user`,
        data: {email: email, password: encryptedPassword},
        method: "POST",
    });
    handleSessionTimeout(response.data);
    if (get(response, ['data', 'success'], true)) {
        localStorage.setItem(
            "authToken",
            response.data["data"]["webtoken"]["token"]
        );
        localStorage.setItem(
            "insurerId",
            response.data["data"]["data"]["corporateId"]
        );
        localStorage.setItem(
            "hospitalCode",
            response.data["data"]["corporate"]["hospitalCode"]
        );
        localStorage.setItem(
            "clientPlatform",
            "CLAIM-ENHANCEMENT"
        );
        axios.defaults.headers.common["X-Auth-Token"] = `${localStorage.getItem(
            "authToken"
        )}`;
        axios.defaults.headers.common["X-Client-Platform"] = "CLAIM-ENHANCEMENT";
        axios.defaults.headers.common["X-App-Version"] = process.env.REACT_APP_VERSION;

        localStorage.setItem("role", response.data["data"]["data"]["role"]);
        const metadata = response.data["data"]["metadata"]
        setEnvMetadataIntoLocalStorage(metadata);
        return response;
    } else {
        return response.data;
    }
};

export const ABHIIframeLogin = async (encryptedData) => {
    const response = await axios({
        url: `/validate?data=${encodeURIComponent(encryptedData)}`,
        baseURL: `${baseURL}/user`,
        method: "POST",
    });
    if (get(response, ['data', 'success'], true)) {
        localStorage.setItem(
            "authToken",
            response.data["data"]["token"]
        );
        localStorage.setItem(
            "clientPlatform",
            response.data["data"]["platform"]
        );
        localStorage.setItem(
            "claimNumber",
            response.data["data"]["claimNumber"]
        );
        localStorage.setItem("role", response.data["data"]["role"]);
        localStorage.setItem(
            "hospitalCode",
            "INSURER-1002"
        )

        axios.defaults.headers.common["X-Auth-Token"] = `${localStorage.getItem(
            "authToken"
        )}`;
        axios.defaults.headers.common["X-Client-Platform"] = `${localStorage.getItem(
            "clientPlatform"
        )}`;
        axios.defaults.headers.common["X-App-Version"] = process.env.REACT_APP_VERSION;
        fetchEnvMetaData().then((response) => {
            setEnvMetadataIntoLocalStorage(response.data);
        });

        return response;
    } else {
        return response;
    }
};

export const createNewUser = async (data) => {
    const response = await axios({
        url: "/signup",
        baseURL: `${baseURL}/user`,
        data: data,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error uploading claim");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error Creating User');
    }

    return response.data;
};

export const getClaimListData = async (
    startDate = moment(new Date()).subtract(180, "days").format("YYYY-MM-DD"),
    endDate = moment(new Date()).format("YYYY-MM-DD"),
    attributesNames = "",
    attributeValue = "",
    dateType = "DATE_UPDATED",
    pageSize = 50,
    page = 1
) => {
    localStorage.setItem("pageSize", pageSize);
    localStorage.setItem("page", page);
    let response = await axios({
        url: "/list",
        baseURL: `${baseURL}/i/claim`,
        data: {
            dateTypeFilter: {
                attributeName: dateType,
                startDate: startDate,
                endDate: endDate,
            },
            attributeTypeFilter: {
                attributeName: attributesNames,
                attributeValue: attributeValue,
            },
            pageNo: page + 1,
            pageSize: pageSize,
            insurerId: localStorage.getItem("insurerId"),
        },
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching claim details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Claim Details');
    }
    return response.data;
};
export const getInfoList = async (
    startDate = moment(new Date()).subtract(180, "days").format("YYYY-MM-DD"),
    endDate = moment(new Date()).format("YYYY-MM-DD"),
    dateType = " UPDATED_DATE"
) => {
    let response = await axios({
        url: `/stats?startDate=${startDate}&endDate=${endDate}&dateTypeFilter=${dateType === "DATE_UPDATED" ? "UPDATED_DATE" : "CREATED_DATE"
        }`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching claim stats details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Claim Stats');
    }
    return response.data;
};

export const viewClaimABHIIframe = async (id, jarvisUserId) => {
    let response = await axios({
        url: `/claim?claimNumber=${id}&jarvisUserId=${jarvisUserId}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching claim details");
    }

    return response.data;
};

export const viewClaim = async (id) => {
    let response = await axios({
        url: `/claim/${id}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching claim details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Claim Details');
    }

    return response.data;
};

export const getExcelData = async (startDate, endDate) => {
    const response = await axios({
        url: `/report/claim/download?startDate=${startDate}&endDate=${endDate}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders("blob"),
        responseType: "blob",
    })
        .then((blob) => {
            handleSessionTimeout(blob.data);
            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `claims_data_${Moment(new Date()).format("DD-MM-YYYY,h:mm:ss a")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            throw new Error(error);
        });
    return response;
};

export const getClaimStageReport = async (startDate, endDate) => {
    const response = await axios({
        url: `/report/claim/stage?startDate=${startDate}&endDate=${endDate}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders("blob"),
        responseType: "blob",
    })
        .then((blob) => {
            handleSessionTimeout(blob.data);
            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `claims_data_${Moment(new Date()).format("DD-MM-YYYY,h:mm:ss a")}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            throw new Error(error);
        });
    return response;
};

export const getBusinesReport = async (
    startDate,
    endDate,
    excludeFailedCase,
    includeInsurerFinal
) => {
    const response = await axios({
        url: `/report/business?startDate=${startDate}&endDate=${endDate}&claimDataId=all&excludeFailedCases=${excludeFailedCase}&includeInsurerFinalOnly=${includeInsurerFinal}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders("blob"),
        responseType: "blob",
    })
        .then((blob) => {
            handleSessionTimeout(blob.data);
            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `business_report_${Moment(new Date()).format(
                    "DD-MM-YYYY,h:mm:ss a"
                )}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            throw new Error(error);
        });
    return response;
};
export const getTariffTestingReport = async (startDate, endDate) => {
    const response = await axios({
        url: `/report/tariff/testing?startDate=${startDate}&endDate=${endDate}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders("blob"),
        responseType: "blob",
    })
        .then((blob) => {
            handleSessionTimeout(blob.data);
            const url = window.URL.createObjectURL(new Blob([blob.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
                "download",
                `tariff_testing_report_${Moment(new Date()).format(
                    "DD-MM-YYYY,h:mm:ss a"
                )}.xlsx`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
        .catch((error) => {
            throw new Error(error);
        });
    return response;
};
export const getTariffReport = async (startDate, endDate) => {
    const response = await axios({
        url: `/report/tariff/report?startDate=${startDate}&endDate=${endDate}`,
        baseURL: `${baseURL}/i`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching tariff line-item report");
    }
    if (response.data !== null && response.data !== undefined) {
        showToast(response?.data, "success", response?.data);
    } else {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Tariff line-item report');
    }
    /*.then((blob) => {
      const url = window.URL.createObjectURL(new Blob([blob.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute(
        "download",
        `tariff_report_${Moment(new Date()).format(
          "DD-MM-YYYY,h:mm:ss a"
        )}.xlsx`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    })
    .catch((error) => {
      throw new Error(error);
    });*/
    return response;
};
export const uploadExcel = async (file) => {
    let form = new FormData();
    form.append("excel", file);
    let response = await axios({
        url: "/enhancement/bulk",
        baseURL: `${baseURL}/i/claim`,
        data: form,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error uploading claim");
    }

    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
    }

    if (get(response, ['data', 'success'], true)) {
        showToast(
            "Your file has been uploaded, We are processing the data, Once done we will notify you",
            "success",
            response?.data?.message?.code
        );
    }

    return response.data;
};
export const onboardRoomViaExcel = async (file) => {
    let form = new FormData();
    form.append("excel", file);
    let response = await axios({
        url: "/onboard/room",
        baseURL: `${baseURL}/e/service/type`,
        data: form,
        method: "POST",
        headers: getHeaders('multipart/form-data'),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error uploading claim");
    }

    if (!get(response, ['data', 'success'], true)) {
        if (response?.data?.message?.text == null) {
            let data = response?.data?.data;
            let message = "";
            data.forEach((x) => (message = message.concat(x, ", ")));
            showToast(message, "Error", response?.data, (data?.length * 5000))
        } else {
            showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        }
    }

    if (get(response, ['data', 'success'], true)) {
        showToast(
            "Your file has been uploaded, We are processing the data, Once done we will notify you",
            "success",
            response?.data?.message?.code
        );
    }

    return response.data;
};

export const getMetaDataList = async (fetchReduced) => {
    let endPoint = fetchReduced === true ? "reduced" : "all";
    let response = await axios({
        url: `/metadata/${endPoint}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || "Error fetching procedure list details");
    }
    return response.data;
};

export const getcategoryList = async () => {
    let response = await axios({
        url: "/getcategoryList",
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || "Error fetching procedure list details");
    }
    return response.data;
};
export const getClaimEditData = async (hospitalid,claimid) => {
    let response = await axios({
        url: `/claimeditdata?hospitalid=${hospitalid}&claimId=${claimid}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || "Error fetching procedure list details");
    }
    return response.data;
};
export const getSearchIllnesessData = async (value) => {
    let response = await axios({
        url: `/getSearchIllnesses?searchKeyWord=${value}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        // throw new Error(response?.data?.message?.text || "Error fetching procedure list details");
    }
    return response.data;
};

export const creatingClaim = async (form) => {
    let response = await axios({
        url: "/enhancement",
        baseURL: `${baseURL}/i/claim`,
        data: form,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || "Error uploading claim");
    }

    return response.data;
};

export const rerunClaim = async (data) => {
    let response = await axios({
        url: `/rerun/enhancement?claimDataId=${data.claimId}&claimFlow=${data.claimFlow}&corporateCode=${data.corporateCode}&sendToInsurer=${data.sendToInsurer}`,
        baseURL: `${baseURL}/i/claim`,
        data: null,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (get(response, ['data', 'success'], true) === false) {
        showToast(response?.data?.message?.text, "error", get(response, ['data', 'success'], true));
    } else {
        showToast(
            `Rerunning this claim for ${data.claimFlow}`,
            "success",
            get(response, ['data', 'success'], true)
        );
    }

    return response.data;
};

export const markAssignedClaim = async (data) => {
    let response = await axios({
        url: `/assign?claimDataId=${data.claimId}&value=true&claimDataIdList=${data.claimId}`,
        baseURL: `${baseURL}/i/claim`,
        data: null,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (get(response, ['data', 'success'], true) === false) {
        showToast(response?.data?.message?.text, "error", get(response, ['data', 'success'], true));
    } else {
        showToast(
            `Claims assigned`,
            "success",
            get(response, ['data', 'success'], true)
        );
    }

    return response.data;
};

export const markInsurerFinal = async (id, status) => {
    let response = await axios({
        url: `/i/claim/final/${id}/${status}`,
        baseURL: baseURL,
        method: "PUT",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (get(response, ['data', 'success'], true) === false) {
        showToast(response?.data?.message?.text, "error", get(response, ['data', 'success'], true));
    } else {
        showToast(`Claim send to insurer's view`, "success", get(response, ['data', 'success'], true));
    }
    return response.data;
};

export const changeClaimStatus = async (claimId, status) => {
    if (status === undefined || claimId === undefined) {
        return null;
    }
    let response = await axios({
        url: `/i/claim/update/status?claimDataIdList=${claimId}&enhancementStatus=${status}`,
        baseURL: baseURL,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (get(response, ['data', 'success'], true) === false) {
        showToast(response?.data?.message?.text, "error", get(response, ['data', 'success'], true));
    } else {
        showToast(`Update Claim enhancement status`, "success", get(response, ['data', 'success'], true));
    }
    return response.data;
};

export const updateClaim = async (data) => {
    let response = await axios({
        url:
            `/update`,
        baseURL: `${baseURL}/i/claim`,
        data: data,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            "An Error occured while changing the procedure",
            "error",
            response.status
        );
    } else {
        showToast(`Claim has been updated`, "success", response.status);
    }

    return response.data;
};

export const changeDecision = async (data) => {
    let response = await axios({
        url:
            `/update/decision`,
        baseURL: `${baseURL}/e/claim`,
        data: data,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);

    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            "An Error occurred while changing the decision",
            "error",
            response.status
        );
    } else {
        showToast(`Claim has been updated`, "success", response.status);
    }

    return response.data;
};

const getHeaders = (contentTypeValue) => {
    const head = {
        "X-Client-Platform": `${localStorage.getItem("clientPlatform")}`,
        "X-Auth-Token": `${localStorage.getItem("authToken")}`,
        "X-App-Version": `${process.env.REACT_APP_VERSION}`,
    };
    if (contentTypeValue !== null) {
        head["Content-Type"] = contentTypeValue;
    }
    return head;
};
export const onBoardHospitals = async (data) => {
    const response = await axios({
        url: "/i/corporate/onboard",
        baseURL: `${baseURL}`,
        data: data,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            "An Error occured while onboarding the hospital",
            "error",
            response.status
        );
    } else {
        showToast(
            `Hospital has been onboarded successfully!`,
            "success",
            response.status
        );
    }

    return response.data;
};
export const getClaimProcessingReport = async (page = 1, pageSize = 50) => {
    const response = await axios({
        url: `i/claim/processing/data/false/all?page=${page === 0 ? 1 : page
        }&size=${pageSize}`,
        baseURL: `${baseURL}`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            "An Error occured while fetching claim report",
            "error",
            response.status
        );
    }
    return response.data;
};
export const getBulkRoomsWithHospitalCodeList = async (hospitalCodeList) => {
    const response = await axios({
        url: `e/service/type/all?hospitalList=` + hospitalCodeList,
        baseURL: `${baseURL}`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            response?.data?.data !== null ? response?.data?.data : "An Error occured while fetching claim report",
            "error",
            response.status
        );
    }
    return response.data;
};
export const getAllHospitalRoomsPerHospital = async (hospitalCode) => {
    const response = await axios({
        url: `e/service/type/` + hospitalCode,
        baseURL: `${baseURL}`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            response?.data?.data !== null ? response?.data?.data : "An Error occured while fetching claim report",
            "error",
            response.status
        );
    }
    return response.data;
};
export const deleteAllRoomsPerHospital = async (hospitalCode) => {
    const response = await axios({
        url: `e/service/type/disable/` + hospitalCode,
        baseURL: `${baseURL}`,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            response.data?.data !== null ? response.data?.data : "An Error occured while fetching claim report",
            "error",
            response.status
        );
    }
    return response.data;
};
export const getResponseLogReport = async (entity, id, showResult) => {
    const response = await axios({
        url: `i/report/${entity}/${id}?keepHistory=${showResult}`,
        baseURL: `${baseURL}`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200 || !get(response, ['data', 'success'], true)) {
        showToast(
            "An Error occured while fetching claim report",
            "error",
            response.status
        );
    }

    return response.data;
};
export const fetchDocument = async (id) => {
    await axios({
        url: `/txn/letter/${id}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    })
        .then((response) => {
            handleSessionTimeout(response.data);
            //const binaryData = atob(blob);

            // Create an ArrayBuffer from the binary data
            // const arrayBuffer = new ArrayBuffer(binaryData.length);
            // const uint8Array = new Uint8Array(arrayBuffer);
            // for (let i = 0; i < binaryData.length; i++) {
            //   uint8Array[i] = binaryData.charCodeAt(i);
            // }

            // Create a Blob from the ArrayBuffer
            const blobb = new Blob([response], {type: "application/pdf"});

            // Generate a URL pointing to the Blob
            const blobUrl = URL.createObjectURL(blobb);
            return blobUrl;
        })
        .catch((error) => {
            throw new Error(error);
        });
};
export const getTariffDetails = async (id) => {
    let response = await axios({
        url: `${id}/tariff`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching procedure list details");
    }
    return response.data;
};
export const pushDataToJarvis = async (claimId, jarvisUserId, claimNumber) => {
    let response = await axios({
        url: `update/insurer?claimDataId=${claimId}&claimNumber=${claimNumber}&jarvisUserId=${jarvisUserId}`,
        baseURL: `${baseURL}/e/claim`,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error pushing data to Jarvis");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error Pushing Data to Jarvis');
    }
    return response.data;
};
/**
 * `pc_updated` says whether this save carries Procedure Construct decisions - anything taken in
 * the Procedure Construct Saving panel. It sits at the root beside the line item lists because
 * it is a fact about the save, not about any one line: the lists themselves are the same shape
 * whichever panel filled them.
 */
export const saveEditedTariff = async (claimId, jarvisUserId, editedLines, addedLines, claimNumber, deletedLines, pcUpdated) => {
    let response = await axios({
        url: `tariff/update`,
        baseURL: `${baseURL}/e/claim`,
        method: "POST",
        headers: getHeaders(null),
        data: {
            "claimDataId": claimId,
            "claimNumber": claimNumber,
            "jarvisUserId": jarvisUserId,
            "editedLineItems": editedLines,
            "newLineItems": addedLines,
            "deletedLineItems": deletedLines,
            "pc_updated": Boolean(pcUpdated),
        }
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error editing tariff details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error Editing Tarifff Details');
    }
    return response.data;
};
/**
 * Switch a package-construct claim between its package-applied tariff lines (`packageView` true) and its
 * normal tariff lines. Returns the claim's tariff in the same shape as getTariffDetails.
 */
export const updateTariffPackageView = async (claimId, jarvisUserId, claimNumber, packageView) => {
    let response = await axios({
        url: `tariff/package-view`,
        baseURL: `${baseURL}/e/claim`,
        method: "POST",
        headers: getHeaders(null),
        data: {
            "claimDataId": claimId,
            "claimNumber": claimNumber,
            "jarvisUserId": jarvisUserId,
            "packageView": Boolean(packageView),
        }
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error switching tariff lines");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error switching tariff lines');
    }
    return response.data;
};
export const updateIrdaPayable = async (claimId, billLineName, irdaipayable,jarvisUserId,row_id) => {
    let response = await axios({
        url: `/update/irdaipayble`,
        baseURL: `${baseURL}/i/test`,
        method: "POST",
        headers: getHeaders(null),
        data:{
            claimId: claimId,
            billLineName: billLineName,
            irdaipayable: irdaipayable,
            jarvisUserId:jarvisUserId,
            lineItemRowId:row_id,
        }
    });

    handleSessionTimeout(response.data);

    if (response.status !== 200) {
        throw new Error("Error updating IRDAI payable");
    }

    if (!get(response, ["data", "success"], true)) {
        showToast(
            response?.data?.message?.text,
            "error",
            response?.data?.message?.code
        );
        throw new Error(
            response?.data?.message?.text || "Error updating IRDAI payable"
        );
    }

    return response.data;
};
export const saveEditedPMLData = async (claimId, jarvisUserId, editedLines, claimNumber) => {
    let response = await axios({
        url: `pml/update`,
        baseURL: `${baseURL}/e/claim`,
        method: "POST",
        headers: getHeaders(null),
        data: {
            "claimDataId": claimId,
            "claimNumber": claimNumber,
            "jarvisUserId": jarvisUserId,
            "editedLineItems": editedLines,
        }
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error editing tariff details");
    }
    if (!get(response, ['data', 'success'], true)) {
        throw new Error(response?.data?.message?.text || 'Error Editing Policy Details');
    }
    return response.data;
};

export const editSupportStatus = async (userId, status) => {
    let response = await axios({
        url: `update-support-status/${userId}?status=${status}`,
        baseURL: `${baseURL}/su/support`,
        method: "POST",
        headers: getHeaders(null)
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error editing suppport list details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error editing support list Details');
    }
    return response.data;
};

export const getSupportList = async (page, size) => {
    let response = await axios({
        url: `support-user-status-list?page=${page}&size=${size}`,
        baseURL: `${baseURL}/su/support`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching support list details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Support List Details');
    }
    return response.data;
};

export const getExpenseMappingByCategory = async (expenseMasterCategory) => {
    let response = await axios({
        url: `expense/mapping/${expenseMasterCategory}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching support list details");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Expense Mappings');
    }
    return response.data;
};

export const getStandardRemarkList = async () => {
    let response = await axios({
        url: `config/standard-remark`,
        baseURL: `${baseURL}/i/`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error retrieving standard remark list");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching Standard Remark List');
    }
    return response.data;
}


export const getSTPTableData = async (claimId) => {
    let response = await axios({
        url: `stp-table/${claimId}`,
        baseURL: `${baseURL}/i/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching STP data");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching STP Data');
    }
    return response.data;
}





/**
 * The vNeuron adjudication for one claim - what the Medical Admissibility screen reads.
 *
 * Keyed by the claim's `insurerClaimIdentifier` (from the viewClaim record), not the internal
 * claim id in the route.
 *
 * Note the `/e` segment: this one sits on the external API, not the `/i` the rest of this
 * file defaults to. The host comes from REACT_APP_BACKEND_URL, so pointing that at a local
 * backend is all it takes to run the screen against one.
 *
 * A claim the engine never adjudicated is NOT an error, and this endpoint says so in a shape
 * of its own: HTTP 200 with `{success: false, data: "No VNeuron data found for claim: 123"}`
 * - `data` a plain string where a real payload is an object, and no `message` envelope. That
 * comes back to the caller as-is, untoasted, for the screen to show as an empty state. Only a
 * failure carrying the `message: {text, code}` the rest of this API uses is thrown.
 */
export const getVneuronAdjudication = async (insurerClaimIdentifier) => {
    const response = await axios({
        url: `${insurerClaimIdentifier}/vneuron`,
        baseURL: `${baseURL}/e/claim`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching medical admissibility");
    }
    const failureText = get(response, ['data', 'message', 'text'], null);
    if (!get(response, ['data', 'success'], true) && failureText) {
        showToast(failureText, "error", get(response, ['data', 'message', 'code'], undefined));
        throw new Error(failureText);
    }
    return response.data;
}


export const fetchEnvMetaData = async () => {
    let response = await axios({
        url: `/env-metadata`,
        baseURL: `${baseURL}/i/claim`,
        // baseURL: `${baseURL}`,
        method: "GET",
        headers: getHeaders(null),
    });
    console.log("envMetadata",response.data)
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching support list details");
    }
    if (!get(response, ['data', 'success'], true)) {
        throw new Error(response?.data?.message?.text || 'Error fetching Env Meta Data');
    }
    return response.data;
};


export const logoutAPI = async () => {
    const response = await axios({
        url: "/logout",
        baseURL: `${baseURL}/user`,
        method: "POST",
        headers: getHeaders(null),
    });
    if (response.status !== 200) {
        throw new Error("Error Logging Out");
    }
    handleSessionTimeout(response.data);
    return response.data;
}


export const handleSessionTimeout = (data) => {
    if(data?.message?.code==='USR018'){
        apiErrorBasedRedirection();
    }
    if(data?.message?.code==='USR012'){
        showToast(
            "Platform not be identified. Unauthorised access.",
            "error",
            data.status
        );
        apiErrorBasedRedirection();
    }
}

export const chkPointsLogs = async (servername,apiRequestType,claimnoType,claimNo,startDate,enddate,showhistory) => {
    let response = await axios({
        url: `/getchkPointLogData?servername=${servername}&apiRequestType=${apiRequestType}&claimnoType=${claimnoType}&claimNo=${claimNo}&startDate=${startDate}&endDate=${enddate}&showhistory=${showhistory}`,
        baseURL: `${baseURL}/e`,
        data: null,
        method: "GET",
        headers: getHeaders(null),
    });
    return response.data;
};
export const apiReqEnumsNames = async () => {
    let response = await axios({
        url: `/getReqApiType`,
        baseURL: `${baseURL}/e`,
        data: null,
        method: "GET",
        headers: getHeaders(null),
    });
    return response.data;
};
export const apichkPointsLogsData = async (id) => {
    let response = await axios({
        url: `/getchkData?id=${id}`,
        baseURL: `${baseURL}/e`,
        data: null,
        method: "GET",
        headers: getHeaders(null),
    });
    return response.data;
};

/**
 * Sends the authorization-letter HTML to the backend, which renders it into the
 * requested format (PDF / DOCX / PNG) and returns the file as a binary stream.
 * The returned blob is then downloaded in the browser.
 *
 * @param {Object} params
 * @param {string} params.html          - Rendered letter HTML.
 * @param {"pdf"|"docx"|"png"} params.downloadType - Desired output format.
 * @param {string} [params.claimId]     - Optional claim id for context/naming.
 * @param {string} [params.fileName]    - Optional file base name (without extension).
 * @param {boolean} [params.edited]     - true when the user manually edited the
 *                                        letter; false to reuse the saved/first
 *                                        response HTML as-is.
 */
export const downloadAuthorizationLetter = async ({html, downloadType, claimId, fileName, edited = false}) => {
    const typeMeta = {
        pdf: {ext: "pdf", mime: "application/pdf"},
        docx: {
            ext: "docx",
            mime: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        },
        png: {ext: "png", mime: "image/png"},
    };
    const meta = typeMeta[downloadType];
    if (!meta) {
        throw new Error(`Unsupported download type: ${downloadType}`);
    }

    const response = await axios({
        url: `/authorization-letter/download`,
        baseURL: `${baseURL}/i/`,
        method: "POST",
        data: {html, downloadType, claimId, edited},
        headers: getHeaders("application/json"),
        responseType: "blob",
    });

    if (response.status !== 200) {
        throw new Error("Error generating authorization letter");
    }

    // The backend can return an error as JSON *even with a 200 status*. Because
    // responseType is "blob", such a payload would otherwise be saved as a
    // corrupt .pdf/.docx/.png. Detect a JSON blob, surface the real error, and
    // run the usual session-timeout handling.
    const respType = response.data?.type || "";
    if (respType.includes("application/json") || respType.includes("text/")) {
        const text = await response.data.text();
        let payload;
        try {
            payload = JSON.parse(text);
        } catch (e) {
            payload = null;
        }
        handleSessionTimeout(payload);
        throw new Error(
            payload?.message?.description ||
                payload?.message ||
                "Error generating authorization letter"
        );
    }

    const blob = new Blob([response.data], {type: meta.mime});
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const base = fileName || `Authorization_Letter_${claimId || Moment(new Date()).format("DD-MM-YYYY")}`;
    link.href = url;
    link.setAttribute("download", `${base}.${meta.ext}`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
    return true;
};

/**
 * Fetches the existing (already saved) authorization letter for a claim.
 * Returns the raw API payload, e.g. { success, data: { id, claimId, html,
 * downloadType, fileName, createdBy, createdDate } }.
 *
 * @param {string|number} claimId - Claim id whose saved letter should be fetched.
 */
export const getAuthorizationLetter = async (claimId) => {
    if (!claimId && claimId !== 0) {
        throw new Error("claimId is required to fetch the authorization letter");
    }

    const response = await axios({
        url: `/authorization-letter/download/${claimId}`,
        baseURL: `${baseURL}/i/`,
        method: "GET",
        headers: getHeaders(null),
    });

    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching authorization letter");
    }
    return response.data;
};
export const applyDiscounts = async (discountsArray) => {
    let response = await axios({
        url: `/applydiscount`,
        baseURL: `${baseURL}/i/test`,
        data: discountsArray,
        method: "POST",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error applying discounts");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error applying discounts');
    }
    return response.data;
};

export const getCMBulk = async (claimId) => {
    let response = await axios({
        url: `/getCM_BULK/claimId/${claimId}`,
        baseURL: `${baseURL}/i/test`,
        method: "GET",
        headers: getHeaders(null),
    });
    handleSessionTimeout(response.data);
    if (response.status !== 200) {
        throw new Error("Error fetching CM Bulk data");
    }
    if (!get(response, ['data', 'success'], true)) {
        showToast(response?.data?.message?.text, "error", response?.data?.message?.code);
        throw new Error(response?.data?.message?.text || 'Error fetching CM Bulk data');
    }
    return response.data;
};


